<template>
  <router-link
    to="route/active"
    class="c-active-route"
  >
    <h4 class="c-active-route__title">Actieve route</h4>
    <o-route-graph :current-position="26">
      <o-route-bar
        mode="start"
      />
      <o-route-bar
        mode="walk"
        icon="walk"
        width="12.5"
        :inactive="true"
      />
      <o-route-bar
        mode="ov"
        icon="tram"
        width="25"
      />
      <o-route-bar
        mode="train"
        icon="train"
        width="50"
      />
      <o-route-bar
        mode="ov"
        icon="tram"
        width="25"
      />
      <o-route-bar
        mode="walk"
        icon="walk"
        width="12.5"
      />
      <o-route-bar
        mode="destination"
      />
    </o-route-graph>
    <div class="c-active-route__meta">
      <div class="c-active-route__from">Ajuinlei, Gent</div>
      <div class="c-active-route__to">Eiermarkt, Antwerpen</div>
    </div>
  </router-link>
</template>

<script>
import ORouteBar from '@/components/ORouteBar.vue'
import ORouteGraph from '@/components/ORouteGraph.vue'
export default {
  name: 'OActiveRoute',
  components: {
    ORouteBar,
    ORouteGraph
  }
}
</script>

<style lang="scss">
.c-active-route {
  background: #fff;
  border-radius: 0 0 $border-radius-large $border-radius-large;
  box-shadow: $box-shadow;
  display: block;
  padding: 1.6rem;
  position: relative;
}

.c-active-route__title {
  color: $gray-500;
  font-size: 1.2rem;
  margin-bottom: 0.8rem;
  text-transform: uppercase;
}

.c-route-graph {
  margin-bottom: 0.8rem;
}

.c-active-route__meta {
  align-items: center;
  display: flex;
  font-size: 1.3rem;
  font-weight: 600;
}

.c-active-route__to {
  margin-left: auto;
  text-align: right;
}
</style>
